// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1yVdj","info":"UpdateTermsInfo_info__13te9"};